import { postApi } from "./api_instance";

export const forgotPassword = async ({ email, userType }, dispatch) => {
  try {
    const { data } = await postApi({
      apiUrl: "/api/user/passwordResetRequest",
      dispatch,
      data: {
        email,
        user_type: userType,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
